<template>
  <div id="app">
    <router-view name="landing"></router-view>
    <router-view name="app"></router-view>
    <router-view name="preferences"></router-view>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      this.$lang.setLang('us');
    }
  }
</script>

<style lang="scss">
  @import '@/scss/00_generic/import-generic.scss';
</style>
